angular.module('admin.politics.add', [
  'services.formErrors'
]).config(["$stateProvider", function ($stateProvider) {
  $stateProvider
    .state('admin.politics.add', {
      url: '/add',
      title: 'Politics / Add new',
      views: {
        'main@': {
          template: require('./admin-politics-add.tpl.html'),
          controller: 'PoliticsAddCtrl'
        }
      }
    });
}]).controller('PoliticsAddCtrl', ["$scope", "formErrors", "$location", function ($scope, formErrors, $location) {

}]);



// WEBPACK FOOTER //
// ./client/src/app/admin/politics/admin-politics-add.js